
import { create } from 'zustand';
import { Token } from 'types/tokens';
import { Network } from 'types/networks';

const findTokenAddressBySymbol = (tokens: Token[], symbol: string) => {
  return tokens.find(token =>
    token.symbol.toLowerCase().includes(symbol.toLowerCase())
  );
};

type NetworksStore = {
  networks: Network[] | null;
  setNetworks: (networks: Network[] | null) => void;
  currentNetwork: Network | null;
  setCurrentNetwork: (network: Network | null) => void;
  usdtToken: Token | null;
  usdcToken: Token | null;
};

export const networksStore = create<NetworksStore>(set => {
  const savedNetwork = localStorage.getItem('currentNetwork');
  const initialNetwork = savedNetwork ? JSON.parse(savedNetwork) : null;
  const usdtToken = findTokenAddressBySymbol(
    initialNetwork?.depositTokens ?? [],
    'USDT'
  );
  const usdcToken = findTokenAddressBySymbol(
    initialNetwork?.depositTokens ?? [],
    'USDC'
  );

  return {
    networks: null,
    usdtToken: usdtToken ?? null,
    usdcToken: usdcToken ?? null,
    setNetworks: networks => set({ networks }),
    currentNetwork: initialNetwork,
    setCurrentNetwork: network => {
      if (network) {
        localStorage.setItem('currentNetwork', JSON.stringify(network));
      } else {
        localStorage.removeItem('currentNetwork');
      }

      const usdtToken = findTokenAddressBySymbol(
        network?.depositTokens ?? [],
        'USDT'
      );
      const usdcToken = findTokenAddressBySymbol(
        network?.depositTokens ?? [],
        'USDC'
      );

      set({ usdtToken: usdtToken });

      set({ usdcToken: usdcToken });

      set({ currentNetwork: network });
    },
  };
});

export const useNetworksStore = networksStore;
